export const GET_USER = "GET_USER";
export const GET_USER_DETAILS = "GET_USER_DETAILS";
export const GET_USERS = "GET_USERS";
export const GET_USER_LIST = "GET_USER_LIST";
export const ARCHIVE_USER = "ARCHIVE_USER";
export const UNARCHIVE_USER = "UNARCHIVE_USER";
export const INSERT_USER = "INSERT_USER";
export const UPDATE_USER = "UPDATE_USER";
export const TRACK_USER_ACTIVITY = "TRACK_USER_ACTIVITY";
export const GET_USER_CLIENTS = "GET_USER_CLIENTS";
export const GET_USER_ASSIGNED_CLIENTS = "GET_USER_ASSIGNED_CLIENTS";
export const GET_USER_ROLES_V2 = "GET_USER_ROLES_V2";
export const GET_HOME_PAGE_DATA = "GET_HOME_PAGE_DATA";
export const USER_LOGOUT = "USER_LOGOUT";

export const GET_CLIENTS = "GET_CLIENTS";
export const GET_CLIENT = "GET_CLIENT";
export const GET_CLIENT_BY_OVCID = "GET_CLIENT_BY_OVCID";
export const SET_SELECTED_CLIENT_ID = "SET_SELECTED_CLIENT_ID";
export const SET_SELECTED_CLIENT = "SET_SELECTED_CLIENT";
export const GET_CLIENTS_USERS = "GET_CLIENTS_USERS";
export const GET_CLIENTS_USER_ROLES = "GET_CLIENTS_USER_ROLES";
export const INSERT_CLIENT = "INSERT_CLIENT";
export const UPDATE_CLIENT = "UPDATE_CLIENT";
export const UPDATE_CLIENTS_USER = "UPDATE_CLIENTS_USER";
export const INSERT_CLIENTS_USER = "INSERT_CLIENTS_USER";
export const SAVE_CLIENT_ROLES = "SAVE_CLIENT_ROLES";

export const GET_LEASE_EVENTS = "GET_LEASE_EVENTS";
export const GET_LEASE_EVENT_SPREADSHEET = "GET_LEASE_EVENT_SPREADSHEET";
export const GET_LEASE_EVENTS_BY_IDS = "GET_LEASE_EVENTS_BY_IDS";
export const GET_LEASE_EVENT = "GET_LEASE_EVENT";
export const GET_LEASE_EVENTS_SNOOZED = "GET_LEASE_EVENTS_SNOOZED";
export const GET_LEASE_EVENTS_IGNORED = "GET_LEASE_EVENTS_IGNORED";
export const SNOOZE_LEASE_EVENTS = "SNOOZE_LEASE_EVENTS";
export const IGNORE_LEASE_EVENTS = "IGNORE_LEASE_EVENTS";
export const UNSNOOZE_LEASE_EVENTS = "SNOOZE_LEASE_EVENTS";
export const UNIGNORE_LEASE_EVENTS = "IGNORE_LEASE_EVENTS";
export const GET_ALL_LEASE_EVENTS = "GET_ALL_LEASE_EVENTS";
export const GET_ALL_LEASE_EVENTS_SNOOZED = "GET_ALL_LEASE_EVENTS_SNOOZED";
export const GET_ALL_LEASE_EVENTS_IGNORED = "GET_ALL_LEASE_EVENTS_IGNORED";
export const GET_LEASE_EVENT_FILTER_OPTIONS = "GET_LEASE_EVENT_FILTER_OPTIONS";
export const GET_DISTINCT_LEASE_EVENT_REGIONS = "GET_DISTINCT_LEASE_EVENT_REGIONS";
export const GET_EVENTS_LEASE_NAMES = "GET_EVENTS_LEASE_NAMES";
export const GET_LEASE_EVENT_STATUSES = "GET_LEASE_EVENT_STATUSES";
export const RESET_LEASE_EVENT_COMMENTS = "RESET_LEASE_EVENT_COMMENTS";
export const GET_LEASE_EVENT_COMMENTS = "GET_LEASE_EVENT_COMMENTS";
export const CREATE_LEASE_EVENT_COMMENT = "CREATE_LEASE_EVENT_COMMENT";
export const UPDATE_LEASE_EVENT_COMMENT = "UPDATE_LEASE_EVENT_COMMENT";
export const DELETE_LEASE_EVENT_COMMENT = "DELETE_LEASE_EVENT_COMMENT";
export const GET_LEASE_EVENT_PAGE_SIZE = "GET_LEASE_EVENT_PAGE_SIZE";

export const GET_LEASES = "GET_LEASES";
export const GET_LEASE_SPREADSHEET = "GET_LEASE_SPREADSHEET";
export const GET_LEASE = "GET_LEASE";
export const GET_LEASE_FILTER_OPTIONS = "GET_LEASE_FILTER_OPTIONS";
export const GET_DISTINCT_LEASE_REGIONS = "GET_DISTINCT_LEASE_REGIONS";
export const GET_LEASE_NAMES = "GET_LEASE_NAMES";
export const GET_LEASE_CITIES = "GET_LEASE_CITIES";
export const GET_LEASE_STATE_PROVINCES = "GET_LEASE_STATE_PROVINCES";
export const GET_LEASE_COUNTRIES = "GET_LEASE_COUNTRIES";
export const GET_LEASE_TYPES = "GET_LEASE_TYPES";
export const GET_LEASE_STATUSES = "GET_LEASE_STATUSES";
export const GET_LEASE_EVENT_TYPES = "GET_LEASE_EVENT_TYPES";
export const GET_TENURE_TYPES = "GET_TENURE_TYPES";
export const GET_RELATED_LEASE_EVENTS = "GET_RELATED_LEASE_EVENTS";
export const GET_ALL_LEASES = "GET_ALL_LEASES";
export const GET_LEASE_PAGE_SIZE = "GET_LEASE_PAGE_SIZE";

export const GET_PROPERTIES = "GET_PROPERTIES";
export const GET_PROPERTY = "GET_PROPERTY";
export const GET_PROPERTY_BY_IDS = "GET_PROPERTY_BY_IDS";
export const GET_PROPERTY_SPREADSHEET = "GET_PROPERTY_SPREADSHEET";
export const GET_PROPERTY_FILTER_OPTIONS = "GET_PROPERTY_FILTER_OPTIONS";
export const GET_PROPERTY_NAMES = "GET_PROPERTY_NAMES";
export const GET_PROPERTY_CITIES = "GET_PROPERTY_CITIES";
export const GET_PROPERTY_STATE_PROVINCES = "GET_PROPERTY_STATE_PROVINCES";
export const GET_PROPERTY_COUNTRIES = "GET_PROPERTY_COUNTRIES";
export const GET_PROPERTY_CAMPUS_FACILITIES = "GET_PROPERTY_CAMPUS_FACILITIES";
export const GET_PROPERTY_TYPES = "GET_PROPERTY_TYPES";
export const GET_PROPERTY_STATUSES = "GET_PROPERTY_STATUSES";
export const GET_DISTINCT_CLIENT_REGIONS = "GET_DISTINCT_CLIENT_REGIONS";
export const GET_ASSOCIATED_LEASE = "GET_ASSOCIATED_LEASE";
export const GET_ALL_PROPERTIES = "GET_ALL_PROPERTIES";
export const GET_PROPERTIES_PAGE_SIZE = "GET_PROPERTIES_PAGE_SIZE";

export const GET_TRANSACTIONS = "GET_TRANSACTIONS";
export const GET_PRE_TRANSACTIONS_LIST = "GET_PRE_TRANSACTIONS_LIST";
export const GET_TRANSACTION_SPREADSHEET = "GET_TRANSACTION_SPREADSHEET";
export const GET_TRANSACTION = "GET_TRANSACTION";
export const GET_PRE_TRANSACTION = "GET_PRE_TRANSACTION";
export const GET_TRANSACTION_COMMENTS = "GET_TRANSACTION_COMMENTS";
export const GET_TRANSACTION_DOCUMENTS = "GET_TRANSACTION_DOCUMENTS";
export const GET_TRANSACTION_DOCUMENT_URL = "GET_TRANSACTION_DOCUMENT_URL";
export const GET_TRANSACTION_TEMPLATES = "GET_TRANSACTION_TEMPLATES";
export const GET_TRANSACTION_DEFAULT_STEPS = "GET_TRANSACTION_DEFAULT_STEPS";
export const GET_TRANSACTION_DEFAULT_TASKS = "GET_TRANSACTION_DEFAULT_TASKS";
export const GET_TRANSACTION_STEPS = "GET_TRANSACTION_STEPS";
export const GET_TRANSACTION_STEP_COMMENTS = "GET_TRANSACTION_STEP_COMMENTS";
export const GET_TRANSACTION_STEPS_DOCUMENTS =
  "GET_TRANSACTION_STEPS_DOCUMENTS";
export const ADD_TRANSACTION_STEP_DOCUMENT = "ADD_TRANSACTION_STEP_DOCUMENT";
export const UPDATE_TRANSACTION_STEP_DOCUMENT =
  "UPDATE_TRANSACTION_STEP_DOCUMENT";
export const DELETE_TRANSACTION_STEP_DOCUMENT =
  "DELETE_TRANSACTION_STEP_DOCUMENT";

export const UPDATE_TRANSACTION_STEP_DUE_DATE =
  "UPDATE_TRANSACTION_STEP_DUE_DATE";
export const UPDATE_TRANSACTION_STEP_STATUS = "UPDATE_TRANSACTION_STEP_STATUS";

export const GET_TRANSACTION_TASKS = "GET_TRANSACTION_TASKS";
export const GET_TRANSACTION_TASKS_UNCOMPLETED =
  "GET_TRANSACTION_TASKS_UNCOMPLETED";
export const ADD_TRANSACTION_TASK = "ADD_TRANSACTION_TASK";
export const REORDER_TRANSACTION_TASKS = "REORDER_TRANSACTION_TASKS";
export const UPDATE_TRANSACTION_TASK = "UPDATE_TRANSACTION_TASK";
export const DELETE_TRANSACTION_TASKS = "DELETE_TRANSACTION_TASKS";
export const GET_ADDRESS_DETAILS = "GET_ADDRESS_DETAILS";
export const GET_TRANSACTION_PAGE_SIZE = "GET_TRANSACTION_PAGE_SIZE";

export const GET_PIPELINES = "GET_PIPELINES";
export const GET_PIPELINES_FILTERS = "GET_PIPELINES_FILTERS";
export const GET_LOGINAGGREGATION = "GET_LOGINAGGREGATION";
export const GET_UNIQUELOGINAGGREGATION = "GET_UNIQUELOGINAGGREGATION";
export const GET_LOGINHISTORY = "GET_LOGINHISTORY";
export const GET_TOTALPAGEVIEWPERCLIENT = "GET_TOTALPAGEVIEWPERCLIENT";
export const GET_PAGEVIEWPERCLIENT = "GET_PAGEVIEWPERCLIENT";
export const GET_TRANSACTIONSCREATED = "GET_TRANSACTIONSCREATED";
export const GET_PRETRANSACTIONSCREATED = "GET_PRETRANSACTIONSCREATED";
export const CLEAR_TRANSACTION_DETAILS = "CLEAR_TRANSACTION_DETAILS";
export const SET_TRANSACTION_FILTERS = "SET_TRANSACTION_FILTERS";

export const UPLOAD_FILE_EDP = "UPLOAD_FILE_EDP";
export const GET_MANUAL_UPLOAD_FILES = "GET_MANUAL_UPLOAD_FILES";
export const GET_UPLOAD_FILES_LOGS = "GET_UPLOAD_FILES_LOGS";
export const GET_UPLOADED_FILE_SAS = "GET_UPLOADED_FILE_SAS";

export const UPDATE_TRANSACTION_AT_RISK = "UPDATE_TRANSACTION_AT_RISK";
export const UPDATE_TRANSACTION_ON_HOLD = "UPDATE_TRANSACTION_ON_HOLD";

export const GET_TRANSACTION_FILTER_OPTIONS = "GET_TRANSACTION_FILTER_OPTIONS";
export const GET_TRANSACTION_NAMES = "GET_TRANSACTION_NAMES";
export const GET_TRANSACTION_CITIES = "GET_TRANSACTION_CITIES";
export const GET_TRANSACTION_STATE_PROVINCES =
  "GET_TRANSACTION_STATE_PROVINCES";
export const GET_TRANSACTION_COUNTRIES = "GET_TRANSACTION_COUNTRIES";
export const GET_TRANSACTION_TYPES = "GET_TRANSACTION_TYPES";

export const GET_TRANSACTION_TYPES_CUSTOM = "GET_TRANSACTION_TYPES_CUSTOM";
export const ADD_TRANSACTION_TYPE_CUSTOM = "ADD_TRANSACTION_TYPE_CUSTOM";
export const UPDATE_TRANSACTION_TYPES_CUSTOM = "UPDATE_TRANSACTION_TYPES_CUSTOM";
export const DELETE_TRANSACTION_TYPE_CUSTOM = "DELETE_TRANSACTION_TYPE_CUSTOM";

export const GET_TRANSACTION_MANAGERS = "GET_TRANSACTION_MANAGERS";
export const GET_TRANSACTION_CLIENT_MANAGERS = "GET_TRANSACTION_CLIENT_MANAGERS";
export const GET_TRANSACTION_STATUSES = "GET_TRANSACTION_STATUSES";
export const UPDATE_TRANSACTION_STATUS = "UPDATE_TRANSACTION_STATUS";
export const GET_TRANSACTION_BUSINESS_UNITS = "GET_TRANSACTION_BUSINESS_UNITS";
export const SAVE_TRANSACTION = "SAVE_TRANSACTION";
export const UPDATE_TRANSACTION = "UPDATE_TRANSACTION";
export const CANCEL_TRANSACTION = "CANCEL_TRANSACTION";
export const UPDATE_TRANSACTION_UPLOAD_STATUS =
  "UPDATE_TRANSACTION_UPLOAD_STATUS";
export const ASSIGN_PRE_TRANSACTION_TO_TRANSACTION =
  "ASSIGN_PRE_TRANSACTION_TO_TRANSACTION";
export const ASSIGN_LEASE_EVENTS_TO_TRANSACTION =
  "ASSIGN_LEASE_EVENTS_TO_TRANSACTION";
export const ASSIGN_PROPERTIES_TO_TRANSACTION =
  "ASSIGN_PROPERTIES_TO_TRANSACTION";
export const GET_TRANSACTION_ASSOCIATED_PROPERTIES =
  "GET_TRANSACTION_ASSOCIATED_PROPERTIES";
export const GET_TRANSACTION_ASSOCIATED_LEASE_EVENTS =
  "GET_TRANSACTION_ASSOCIATED_LEASE_EVENTS";
export const GET_TRANSACTION_ASSOCIATED_PRE_TRANSACTION =
  "GET_TRANSACTION_ASSOCIATED_PRE_TRANSACTION";
export const GET_ALL_TRANSACTIONS = "GET_ALL_TRANSACTIONS";
export const DELETE_TRANSACTION = "DELETE_TRANSACTION";
export const UNDELETE_TRANSACTION = "UNDELETE_TRANSACTION";
export const DELETE_TRANSACTION_ASSOCIATED_PROPERTIES =
  "DELETE_TRANSACTION_ASSOCIATED_PROPERTIES";
export const DELETE_TRANSACTION_ASSOCIATED_LEASE_EVENTS =
  "DELETE_TRANSACTION_ASSOCIATED_LEASE_EVENTS";
export const DELETE_TRANSACTION_ASSOCIATED_PRE_TRANSACTION =
  "DELETE_TRANSACTION_ASSOCIATED_PRE_TRANSACTION";

export const GET_REGIONS = "GET_REGIONS";
export const GET_COUNTRIES = "GET_COUNTRIES";
export const GET_STATES = "GET_STATES";
export const GET_DEFAULT_VALUES_ON_COUNTRY = "GET_DEFAULT_VALUES_ON_COUNTRY";
export const GET_RENT_PERIOD = "GET_RENT_PERIOD";
export const GET_UNITS_OF_MEASUREMENT = "GET_UNITS_OF_MEASUREMENT";
export const GET_COST_CURRENCY = "GET_COST_CURRENCY";
export const GET_DISTINCT_USER_ROLES = "GET_DISTINCT_USER_ROLES";

export const GET_COLUMN_SETTINGS = "GET_COLUMN_SETTINGS";
export const GET_COLUMN_SETTINGS_PRE_TRANSACTION_LIST =
  "GET_COLUMN_SETTINGS_PRE_TRANSACTION_LIST";
export const GET_COLUMN_SETTINGS_TRANSACTION_LIST =
  "GET_COLUMN_SETTINGS_TRANSACTION_LIST";
export const GET_COLUMN_SETTINGS_LEASE_EVENTS_LIST =
  "GET_COLUMN_SETTINGS_LEASE_EVENTS_LIST";
export const GET_COLUMN_SETTINGS_LEASE_EVENTS_LIST_ALL=
  "GET_COLUMN_SETTINGS_LEASE_EVENTS_LIST_ALL";  
export const GET_COLUMN_SETTINGS_SNOOZED_LEASE_EVENTS_LIST =
  "GET_COLUMN_SETTINGS_SNOOZED_LEASE_EVENTS_LIST";
export const GET_COLUMN_SETTINGS_IGNORED_LEASE_EVENTS_LIST =
  "GET_COLUMN_SETTINGS_IGNORED_LEASE_EVENTS_LIST";
export const GET_COLUMN_SETTINGS_LEASE_LIST = "GET_COLUMN_SETTINGS_LEASE_LIST";
export const GET_COLUMN_SETTINGS_PROPERTY_LIST =
  "GET_COLUMN_SETTINGS_PROPERTY_LIST";

export const SET_COLUMN_VISIBILITY = "SET_COLUMN_VISIBILITY";
export const SET_COLUMN_ORDER = "SET_COLUMN_ORDER";

export const GET_FILTER_SETTINGS = "GET_FILTER_SETTINGS";
export const SET_FILTER_SETTINGS = "SET_FILTER_SETTINGS";

export const GET_ACTIVE_DIRECTORY_USERS = "GET_ACTIVE_DIRECTORY_USERS";

export const UPDATE_TRANSACTION_COMMENT = "UPDATE_TRANSACTION_COMMENT";
export const CREATE_TRANSACTION_COMMENT = "CREATE_TRANSACTION_COMMENT";
export const DELETE_TRANSACTION_COMMENT = "DELETE_TRANSACTION_COMMENT";
export const GET_LAST_STEP_OF_PRE_TRANSACTION =
  "GET_LAST_STEP_OF_PRE_TRANSACTION";
export const GET_TRANSACTION_AUDITS = "GET_TRANSACTION_AUDITS";
export const RESET_TRANSACTION_COMMENTS = "RESET_TRANSACTION_COMMENTS";
export const RESET_PRE_TRANSACTION_ASSOCIATED =
  "RESET_PRE_TRANSACTION_ASSOCIATED";
export const CREATE_TRANSACTION_FROM_PRETRANSACTION =
  "CREATE_TRANSACTION_FROM_PRETRANSACTION";
export const UPDATE_TRANSACTION_TEMPLATE = "UPDATE_TRANSACTION_TEMPLATE";
export const ADD_TRANSACTION_TEMPLATE = "ADD_TRANSACTION_TEMPLATE";
export const DELETE_TRANSACTION_TEMPLATE = "DELETE_TRANSACTION_TEMPLATE";
export const GET_TRANSACTION_UDF = "GET_TRANSACTION_UDF";
export const UPDATE_TRANSACTION_UDF = "UPDATE_TRANSACTION_UDF";
export const RESET_TRANSACTION_DETAILS = "RESET_TRANSACTION_DETAILS";
export const UPDATE_TRANSACTION_STEP_DATES = "UPDATE_TRANSACTION_STEP_DATES";
export const COMPLETE_TRANSACTION = "COMPLETE_TRANSACTION";

export const GET_USER_NOTIFICATIONS = "GET_USER_NOTIFICATION";
export const MARK_NOTIFICATIONS_AS_READ = "MARK_NOTIFICATIONS_AS_READ";
export const REFRESH_CACHE = "REFRESH_CACHE";
export const SET_SELECTED_NOTIFICATION_COMMENT = "SET_SELECTED_NOTIFICATION_COMMENT";
export const RESET_SELECTED_NOTIFICATION_COMMENT = "RESET_SELECTED_NOTIFICATION_COMMENT";
export const GET_UNREAD_NOTIFICATION_COUNT = "GET_UNREAD_NOTIFICATION_COUNT";
export const RESET_NOTIFICATIONS = "RESET_NOTIFICATIONS";
export const GET_USER_SETTINGS = "GET_USER_SETTINGS";
export const UPDATE_USER_SETTINGS = "UPDATE_USER_SETTINGS";
export const GET_USER_DEFAULT_SETTINGS = "GET_USER_DEFAULT_SETTINGS";
export const GET_NOTIFICATION_BY_ID = "GET_NOTIFICATION_BY_ID";
export const SET_TRANSACTION_FILTER_OVERRIDE = "SET_TRANSACTION_FILTER_OVERRIDE";
export const RESET_TRANSACTION_FILTER_OVERRIDE = "RESET_TRANSACTION_FILTER_OVERRIDE";
export const UPDATE_PAGE_SIZE = "UPDATE_PAGE_SIZE";
export const GET_PAGE_SIZE = "GET_PAGE_SIZE";
export const GET_TRANSACTION_BY_ID = "GET_TRANSACTION_BY_ID";
export const DUPLICATE_TRANSACTION = "DUPLICATE_TRANSACTION";
export const CLEAR_TAT_CACHE = "CLEAR_TAT_CACHE";
export const CLEAR_DUPLICATE_TRANSACTION = "CLEAR_DUPLICATE_TRANSACTION";
export const UPDATE_EXCLUDE_PRE_TRANSACTION = "UPDATE_EXCLUDE_PRE_TRANSACTION";
export const GET_EXCLUDE_PRE_TRANSACTION = "GET_EXCLUDE_PRE_TRANSACTION";
export const UPDATE_DEFAULT_STEP = "UPDATE_DEFAULT_STEP";
export const UPDATE_DEFAULT_TASK = "UPDATE_DEFAULT_TASK";
export const REQUEST_TO_DELETE_TRANSACTION = "REQUEST_TO_DELETE_TRANSACTION";
export const CANCEL_TRANSACTION_DELETE_REQUEST = "CANCEL_TRANSACTION_DELETE_REQUEST";
export const GET_TRANSACTION_DELETE_STATUS = "GET_TRANSACTION_DELETE_STATUS";
export const SET_COLUMN_VISIBILITY_DRAWER = "SET_COLUMN_VISIBILITY_DRAWER";
export const GET_TRANSACTION_ACTIVITY = "GET_TRANSACTION_ACTIVITY";
export const SET_TRANSACTION_ACTIVITY = "SET_TRANSACTION_ACTIVITY";
export const GET_TRANSACTION_APPROVERS = "GET_TRANSACTION_APPROVERS";
export const GET_SELECTED_APPROVERS = "GET_SELECTED_APPROVERS";
export const GET_TRANSACTION_APPROVAL_CARD = "GET_TRANSACTION_APPROVAL_CARD";
export const GET_TRANSACTION_APPROVAL_RESPONSE = "GET_TRANSACTION_APPROVAL_RESPONSE";
export const GET_TRANSACTION_APPROVAL_COMMENTS = "GET_TRANSACTION_APPROVAL_COMMENTS";
export const ADD_TRANSACTION_APPROVAL_RESPONSE = "ADD_TRANSACTION_APPROVAL_RESPONSE";
export const ADD_TRANSACTION_APPROVAL_DOCUMENT = "ADD_TRANSACTION_APPROVAL_DOCUMENT";
export const COMPLETE_TRANSACTION_APPROVAL = "COMPLETE_TRANSACTION_APPROVAL";
export const SEND_APPROVAL_REMINDER = "SEND_APPROVAL_REMINDER";
export const UPDATE_TRANSACTION_APPROVERS = "UPDATE_TRANSACTION_APPROVERS";
export const ADD_TRANSACTION_APPROVER = "ADD_TRANSACTION_APPROVER";
export const REMOVE_TRANSACTION_APPROVER = "REMOVE_TRANSACTION_APPROVER";
export const GET_TRANSACTION_ALL_APPROVAL_RESPONSE = "GET_TRANSACTION_ALL_APPROVAL_RESPONSE";
export const GET_USER_VIEW_SETTINGS = "GET_USER_VIEW_SETTINGS";
export const SAVE_USER_VIEW_SETTING = "SAVE_USER_VIEW_SETTING";
export const UPDATE_USER_VIEW_SETTING = "UPDATE_USER_VIEW_SETTING";
export const DELETE_USER_VIEW_SETTING = "DELETE_USER_VIEW_SETTING";
export const SET_USER_DEFAULT_SETTING = "SET_USER_DEFAULT_SETTING";
export const GET_TRANSACTION_UPLOAD_TEMPLATE = "GET_TRANSACTION_UPLOAD_TEMPLATE";
export const GET_NOTICE_DATE = "GET_NOTICE_DATE";